





































import Vue from "vue";
import iwModal from "@/shared/components/Modal.vue";
import billboardImage from "@/assets/images/artworks/billboard.png";

export default Vue.extend({
    name: "PackInfoModal",

    components: {
        iwModal: iwModal,
    },

    props: {
        packType: {
            type: String,
            required: true,
        },
    },

    data: function() {
        return {
            billboardImage: billboardImage,
        };
    },

    computed: {
        prefix: function(): string {
            return "pack_info_" + this.packType;
        },
    },
});
